import axios from 'axios';
class CenterService {
    getCenter() {
    
        return axios.get('/centreo/notre-centre/'+ 2);
    }

}

export default new CenterService();